import React, { Component } from "react";

class becomeAnInstructor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      iframeError: false
    };
    this.handleIframeError = this.handleIframeError.bind(this);
  }

  handleIframeError = (error) => {
    console.warn("Typeform iframe error:", error);
    this.setState({ iframeError: true });
  };

  render() {
    if (this.state.iframeError) {
      return (
        <div style={{ 
          padding: '20px', 
          border: '1px solid #ccc', 
          borderRadius: '4px',
          backgroundColor: '#f9f9f9',
          textAlign: 'center'
        }}>
          <p>There was an issue loading the instructor application form. Please try refreshing the page.</p>
          <button 
            onClick={() => this.setState({ iframeError: false })}
            style={{
              padding: '8px 16px',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Try Again
          </button>
        </div>
      );
    }

    return (
      <>
        <iframe
          src="https://form.typeform.com/to/MKkatFT1?typeform-medium=embed-snippet"
          width="100%"
          height="600px"
          title="Instructor"
          onError={this.handleIframeError}
          onLoad={() => this.setState({ iframeError: false })}
        />
      </>
    );
  }
}

export default becomeAnInstructor;

//"https://contact701272.typeform.com/to/MKkatFT1"
